const $inject = [];

const checkinInfoFilter = () => {
  return (str) => {
    return str ? _.compact(str.split('\r\n')) : [];
  };
};

checkinInfoFilter.$inject = $inject;

export default checkinInfoFilter;



// WEBPACK FOOTER //
// ./src/filters/checkinInfoFilter.js